export interface Faq {
  q: string
  a: string[]
  list?: string[]
  afterList?: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Bartending & Mixology Instructor Atlas after purchasing?',
    a: ['You receive instant digital access to the materials after your payment is successfully completed.'],
  },
  {
    q: 'What format is it in?',
    a: [
      'All materials are delivered as PDF files. You can print them as handouts or show them on a tablet, screen or projector in your classroom, training bar, restaurant or bartending school.',
    ],
  },
  {
    q: 'Who is it for?',
    a: [
      'It is designed for bartending instructors, bar trainers, mixology educators, bar managers, hospitality trainers and bartending schools. Adjust the content to your students, your level and your own training program.',
    ],
  },
  {
    q: 'What levels does it cover?',
    a: [
      'From beginner to advanced. Training pages include Easy, Standard and Advanced variants, so you can match each class to your students.',
    ],
  },
  {
    q: 'Does it work for bar staff training as well as bartending courses?',
    a: [
      'Yes. The material covers technique, classic cocktails, advanced mixology, spirits, presentation and bar operations, so it works for structured bartending courses, mixology workshops and bar staff onboarding alike.',
    ],
  },
  {
    q: 'Is it really a 100% visual system?',
    a: [
      'Yes. The six volumes contain 300 visual training pages (50 per volume). Each page includes an illustration or diagram, a step-by-step breakdown when it applies, a ❌ common mistake vs. ✅ correct technique comparison, a teaching cue, a drill and a quick check. The five bonuses add practical training tools.',
    ],
  },
  {
    q: 'Does it include ready-to-teach lessons?',
    a: [
      'Yes. The system is built around a simple method — OPEN → CHOOSE → SHOW → TEACH — with lesson plans, practice builds, drills and quick checks you can use right away.',
    ],
  },
  {
    q: 'What topics does it cover?',
    a: [
      'Bartending fundamentals, bar tools, glassware and essential techniques; classic cocktails, international recipes and drink preparation; advanced mixology, molecular techniques and creative cocktails; spirits, liqueurs, flavor profiles and sensory analysis; cocktail presentation, garnishing, menu design and bar operations; and bartending instruction, training programs and practical assessments.',
    ],
  },
  {
    q: 'Does it replace an official bartending certification?',
    a: [
      'No. This is educational training-support material. It does not replace an official bartending or responsible-service certification, or local laws on the sale and service of alcohol. Tastings should only be offered to students of legal drinking age, with responsible-service practices; many drills are designed to be practiced with water.',
      'Results depend on each instructor, student and training context, so no specific results are guaranteed.',
    ],
  },
  {
    q: 'Does it include all six volumes?',
    a: ['Yes. The complete package includes all six visual bartending and mixology training volumes.'],
  },
  {
    q: 'Are the five bonuses included?',
    a: ['Yes. The five listed bonuses are included with the complete package at no additional cost under this offer.'],
  },
  {
    q: 'Does it include videos?',
    a: ['No. This is a digital educational resource package containing PDF materials. Videos are not included.'],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes. The materials are written in English for an international audience, with measurements in ml and oz.'],
  },
  {
    q: 'Can I edit the files?',
    a: ['The materials are provided as PDFs, not editable source files.'],
  },
  {
    q: 'Is this a one-time purchase?',
    a: ['Yes. The listed package is offered as a one-time payment, with no subscription.'],
  },
]
